import React from 'react'

const tones = {
  org_created:     { bg: 'rgba(22, 163, 74, 0.15)', fg: 'var(--success-text)' },
  user_confirmed:  { bg: 'rgba(22, 163, 74, 0.15)', fg: 'var(--success-text)' },
  invite_sent:     { bg: 'rgba(37, 99, 235, 0.15)', fg: 'var(--info-text)' },
  invite_resent:   { bg: 'rgba(37, 99, 235, 0.15)', fg: 'var(--info-text)' },
  org_revoked:     { bg: 'rgba(220, 38, 38, 0.15)', fg: 'var(--danger-text)' },
}

const labels = {
  org_created:    'Org created',
  org_revoked:    'Org revoked',
  user_confirmed: 'User confirmed',
  invite_sent:    'Invite sent',
  invite_resent:  'Invite resent',
}

function humanize(action) {
  if (labels[action]) return labels[action]
  const s = String(action).replace(/_/g, ' ')
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function ActionBadge({ action }) {
  const t = tones[action] ?? { bg: 'var(--neutral-bg)', fg: 'var(--text-primary)' }
  return (
    <span
      style={{
        display: 'inline-flex',
        borderRadius: 4,
        padding: '2px 8px',
        fontSize: 11,
        fontWeight: 600,
        background: t.bg,
        color: t.fg,
        whiteSpace: 'nowrap',
      }}
    >
      {humanize(action)}
    </span>
  )
}
